import type { PageMeta } from "./seo";
import { transitionFaqs } from "./brand-transition-content";

/** Historical identity is intentional on this single English announcement. */
export const BRAND_TRANSITION_PATH = "/bookaclassicisnowdriveshare";
export function brandTransitionMeta(origin: string): PageMeta {
  const canonical = new URL(BRAND_TRANSITION_PATH, origin).href;
  const title = "BookAclassic is now DRIVESHARE";
  const description = "BookAclassic is now DRIVESHARE: one global classic-car community for rental, ownership and experiences. Your listings, bookings and account stay unchanged.";
  return {
    pageIdentity: "DRIVESHARE",
    title, description, canonical,
    ogImage: new URL("/images/journeys-hero.webp", origin).href,
    ogLocale: "en_US",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": canonical,
      url: canonical, name: title, description, inLanguage: "en",
      about: [
        { "@type": "Brand", name: "DRIVESHARE",
          alternateName: ["BookAclassic", "BookAClassic", "BookAclassic by DRIVESHARE"],
          description: "BookAclassic by DRIVESHARE is now DRIVESHARE: one worldwide classic-car community under one global brand.",
          logo: new URL("/logos/ds-logo.svg", origin).href },
      ],
      hasPart: {
        "@type": "FAQPage", "@id": canonical + "#faq",
        mainEntity: transitionFaqs.map(faq => ({
          "@type": "Question", name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    },
  };
}
